import React from 'react'
import Retour from '../components/Retour'

function Tour() {
  return (
    <div> <div>
    <div>
   <div>
<div style={{textAlign:"center", display:"flex", justifyContent: "center", alignItems: "center"}}>
<p style={{fontSize:"50px", marginTop: "30px",width:"90%", fontFamily: "Risque, cursive", color: "red"}}>Au cœur d’une cité, les habitants d’une tour se réveillent un matin et découvrent que leur immeuble est enveloppé d’un brouillard opaque, obstruant portes et fenêtres – une étrange matière noire qui dévore tout ce qui tente de la traverser. Pris au piège, les résidents tentent de s’organiser, mais pour assurer leur survie, ils succombent peu à peu à leurs instincts les plus primitifs, jusqu’à sombrer dans l’horreur…</p>
</div>
<div style={{textAlign:"center"}}> <Retour /></div>
</div>
</div>
</div></div>
  )
}

export default Tour